class ForgotPassword {
    constructor(identification, identificationType, phoneNumber, notificationMethod) {
        this.identification = identification;
        this.identificationType = identificationType;
        this.phoneNumber = phoneNumber;
        this.notificationMethod = notificationMethod;
    }
}

export default ForgotPassword;